import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from '../Modal'
import Button from '../Button'
import { HeaderMed } from '../Text'
import { FLEX_CENTER_CENTER } from '../../utils/styles'

const ModalInner = styled.div`
  background: #fff;
  ${FLEX_CENTER_CENTER};
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  margin: auto;
  border-radius: 4px;
  padding: 1rem;
`

const Message = styled(HeaderMed)`
  padding: 1rem 0;
`

function AlertModal({ onClose, message }) {
  return (
    <Modal onClose={onClose}>
      <ModalInner>
        <Message>{message}</Message>
        <Button onClick={onClose}>OK</Button>
      </ModalInner>
    </Modal>
  )
}

AlertModal.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

AlertModal.defaultProps = {
  onClose: null,
}

export default AlertModal
